import { useCallback, useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import Pagination from '../../Pagination';
import api from '../../apiClient';
import { MdShare } from 'react-icons/md';
import Swal from 'sweetalert2';

const CompanyJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const { companyName } = useParams();  // Get companyName from URL

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0); // Reset page when page size change
  };

  const handlePageClick = (data) => {
    setPage(data.selected);
  };

  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };
  const handleViewJob = (job) => {
    setSelectedJob(job);
  };
  const fetchJobs = useCallback(async () => {
    setLoading(true); // Set loading to true when starting to fetch
    try {
      const response = await api.getJobsPostedByCompany(
        companyName,
        page,
        pageSize,
        sortedColumn,
        sortOrder
      );

      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
    } finally {
      setLoading(false); // Set loading to false after fetching is done
    }
  }, [companyName, page, pageSize, sortedColumn, sortOrder]);

  useEffect(() => {
    fetchJobs();
  }, [companyName, page, pageSize, sortedColumn, sortOrder]);

  const handleBackToList = () => {
    setSelectedJob(null); // Reset selectedJob to show the job list again
  };

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;
  const handleShare = (job) => {
    const slug = `${job.jobId}-${job.jobTitle
      .replace(/\s+/g, "-")
      .toLowerCase()}-${job.companyName.replace(/\s+/g, "-").toLowerCase()}`;
    const shareUrl = `${window.location.origin}/browse-jobs/job-details/${slug}`;
    //const shareUrl = `${window.location.origin}/job-details/${jobId}`; // Or however your public job link is structured

    if (navigator.share) {
      navigator.share({
        title: 'Job Opportunity',
        text: 'Check out this job!',
        url: shareUrl,
      })
        .then(() => console.log('Job shared successfully'))
        .catch((error) => console.error('Error sharing', error));
    } else {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          Swal.fire({
            title: 'Link Copied!',
            text: 'Job link copied to clipboard. You can share it now.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        })
        .catch(() => {
          Swal.fire({
            title: 'Error',
            text: 'Could not copy link. Please try again.',
            icon: 'error'
          });
        });
    }
  };
  return (
    <div className="company-job" style={{ marginTop: '20px', width: '100%', marginLeft: '10px' }}>
      {!selectedJob ? (
        <div className="jobs_list">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div className="spinner-bubble spinner-bubble-primary m-5" />
              <span>Loading...</span>
            </div>
          ) : jobs.length > 0 ? (
            <>
              <div className="table-details-list table-wrapper">
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort('jobTitle')} style={{ cursor: 'pointer' }}>
                        Job Title
                        <span>
                          <span style={{ color: sortedColumn === 'jobTitle' && sortOrder === 'asc' ? 'black' : 'gray' }}>↑</span>
                          <span style={{ color: sortedColumn === 'jobTitle' && sortOrder === 'desc' ? 'black' : 'gray' }}>↓</span>
                        </span>
                      </th>
                      <th onClick={() => handleSort('jobType')} style={{ cursor: 'pointer' }}>
                        Job Type
                        <span>
                          <span style={{ color: sortedColumn === 'jobType' && sortOrder === 'asc' ? 'black' : 'gray' }}>↑</span>
                          <span style={{ color: sortedColumn === 'jobType' && sortOrder === 'desc' ? 'black' : 'gray' }}>↓</span>
                        </span>
                      </th>
                      <th onClick={() => handleSort('skills')} style={{ cursor: 'pointer' }}>
                        Skills
                        <span>
                          <span style={{ color: sortedColumn === 'skills' && sortOrder === 'asc' ? 'black' : 'gray' }}>↑</span>
                          <span style={{ color: sortedColumn === 'skills' && sortOrder === 'desc' ? 'black' : 'gray' }}>↓</span>
                        </span>
                      </th>
                      <th onClick={() => handleSort('numberOfPosition')} style={{ cursor: 'pointer' }}>
                        Vacancy
                        <span>
                          <span style={{ color: sortedColumn === 'numberOfPosition' && sortOrder === 'asc' ? 'black' : 'gray' }}>↑</span>
                          <span style={{ color: sortedColumn === 'numberOfPosition' && sortOrder === 'desc' ? 'black' : 'gray' }}>↓</span>
                        </span>
                      </th>
                      <th>Job Description</th>
                      <th>Share</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobs.map((job) => (
                      <tr key={job.id}>
                        <td title={job.jobCategory === "evergreen" && !job.applicationDeadline
                          ? "This position is always open for hiring. Candidates can apply any time, and HR is open to chat with the right candidates!"
                          : ""}>
                          {job.jobTitle}
                        </td>
                        <td>{job.jobType}</td>
                        <td>{job.skills}</td>
                        <td>
                          {job.jobCategory === "evergreen" && job.numberOfPosition === 0 ? (
                            <h6 style={{ color: 'green' }}>Evergreen job</h6>
                          ) : (
                            job.numberOfPosition
                          )}
                        </td>
                        <td>
                          <Button
                            className='btn btn-secondary btn-rounded'
                            onClick={() => handleViewJob(job)}
                          >
                            View
                          </Button>
                        </td>
                        {/* <td>
                          <Link
                            to={`/jobboxCompanyPage/eachCompanyPage/publicJobDetailsPage`}
                            state={{
                              companyName: companyName,
                              jobId: job.jobId,
                            }}
                            className='btn btn-secondary btn-rounded'
                          >
                            View
                          </Link>
                        </td> */}
                        <td>
                          <span
                            className="cursor-pointer text-success me-2 update" onClick={() => handleShare(job)}>
                            <MdShare size={18} className="text-success" />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Pagination */}
              <Pagination
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                handlePageSizeChange={handlePageSizeChange}
                isPageSizeDisabled={isPageSizeDisabled}
                handlePageClick={handlePageClick}
              />
            </>
          ) : (
            <h1>No jobs found.</h1>
          )}
        </div>
      ) : (
        <div className="selected-job-details">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="mb-0">Job Details</h3>
            <div className="d-flex align-items-center">
              <Button variant="primary" onClick={handleBackToList}>
                Back to Jobs
              </Button>

              <div
                className="d-flex align-items-center text-success ms-3"
                title="Share this job"
                onClick={() => handleShare(selectedJob)}
                style={{ cursor: 'pointer' }}
              >
                <MdShare size={20} className="me-1" />
                <span>Share</span>
              </div>
            </div>

          </div>
          <p><strong>Title:</strong> {selectedJob.jobTitle}</p>
          <p><strong>Type:</strong> {selectedJob.jobType}</p>
          <p><strong>Skills:</strong> {selectedJob.skills}</p>
          <p><strong>Posting Date:</strong> {selectedJob.postingDate}</p>
          <p><strong>Vacancy:</strong> {selectedJob.numberOfPosition}</p>
          <p><strong>Salary:</strong> {selectedJob.salary}</p>
          <p><strong>Location:</strong> {selectedJob.location}</p>
          <strong>Job Summary:</strong>
          <pre className="job-details-text">{selectedJob.jobsummary}</pre>
          <p><strong>Application Deadline:</strong> {selectedJob.applicationDeadline}</p>
        </div>
      )}
    </div>
  );
};

export default CompanyJobs;
